<div class="topbar-search" *ngIf="vm.assistantStoreView() === 'mine'" testId="assistant-management-search-section">
  <div class="topbar-search-row has-controls" testId="assistant-management-search-row">
    <button
      nz-button
      nzType="default"
      type="button"
      class="search-toggle"
      [class.is-active]="vm.mobileSearchExpanded() || !!vm.keyword().trim()"
      (click)="vm.toggleMobileSearch()"
      testId="assistant-management-mobile-search-toggle"
    >
      <i nz-icon [nzType]="vm.mobileSearchExpanded() ? 'close' : 'search'"></i>
    </button>

    <nz-input-group
      nzPrefixIcon="search"
      class="search-input"
      [class.mobile-expanded]="vm.mobileSearchExpanded() || !!vm.keyword().trim()"
      testId="assistant-management-search-input-group"
    >
      <input
        nz-input
        [ngModel]="vm.keyword()"
        (ngModelChange)="vm.updateKeyword($event)"
        [placeholder]="'assistant.management.search.placeholder' | i18n"
        testId="assistant-management-search-input"
      />
    </nz-input-group>

    <div class="toolbar-controls">
      <nz-select
        class="filter-dropdown"
        [ngModel]="vm.selectedSource()"
        (ngModelChange)="vm.updateSource($event)"
        nzDropdownClassName="assistant-select-dropdown"
        [nzPlaceHolder]="'assistant.management.filter.source.all' | i18n"
        testId="assistant-management-source-select"
      >
        <nz-option *ngFor="let item of vm.sourceOptions" [nzValue]="item.value" [nzLabel]="item.labelKey | i18n" />
      </nz-select>

      <nz-select
        class="filter-dropdown"
        [ngModel]="vm.selectedStatus()"
        (ngModelChange)="vm.updateStatus($event)"
        nzDropdownClassName="assistant-select-dropdown"
        [nzPlaceHolder]="'assistant.management.filter.status.all' | i18n"
        testId="assistant-management-status-select"
      >
        <nz-option *ngFor="let item of vm.statusOptions" [nzValue]="item.value" [nzLabel]="item.labelKey | i18n" />
      </nz-select>
    </div>

    <div class="toolbar-actions" *ngIf="vm.shouldShowSelfBuiltActions()" testId="assistant-management-actions">
      <button
        nz-button
        nzType="default"
        type="button"
        class="refresh-btn"
        [nzLoading]="vm.loading()"
        [disabled]="vm.loading()"
        (click)="vm.refreshCurrentAssistantView()"
        testId="assistant-management-refresh-button"
      >
        <i nz-icon nzType="reload" nzTheme="outline"></i>
        {{ 'common.refresh' | i18n }}
      </button>
      <button nz-button nzType="primary" class="create-btn" (click)="vm.openCreateWizard()" testId="assistant-management-create-button">
        <i nz-icon nzType="plus"></i>
        {{ 'assistant.management.action.create' | i18n }}
      </button>
    </div>
  </div>
</div>

<div
  class="page-scroll"
  *ngIf="vm.assistantStoreView() === 'mine'"
  (scroll)="vm.onListScroll($event)"
  testId="assistant-management-page-scroll"
>
  <div class="assistant-count" testId="assistant-management-count">
    {{ 'assistant.management.count.prefix' | i18n }} {{ vm.total }} {{ 'assistant.management.count.suffix' | i18n }}
  </div>

  <nz-spin [nzSpinning]="vm.loading()" testId="assistant-management-spin">
    <div class="assistant-list-scroll" testId="assistant-management-list-scroll">
      <div class="assistant-grid" testId="assistant-management-grid">
        <nz-card
          class="assistant-card"
          *ngFor="let item of vm.filteredAssistants(); let i = index; trackBy: vm.trackById"
          [class.assistant-card-unpaid]="vm.isUnpaid(item) && vm.getPendingPaymentCountdown(item)"
          [testId]="'assistant-management-card-' + i"
        >
          <div class="assistant-countdown-badge" *ngIf="vm.isUnpaid(item) && vm.getPendingPaymentCountdown(item)">
            <span class="countdown-label">
              <i nz-icon nzType="hourglass" nzTheme="outline"></i>
              {{ 'payment.result.countdown.label' | i18n }}
            </span>
            <strong>{{ vm.getPendingPaymentCountdown(item) }}</strong>
          </div>
          <div class="card-top">
            <div class="avatar-wrap">
              <div class="avatar-shell">
                <ng-container *ngIf="item.avatarUrl; else avatarTextFallback">
                  <img class="avatar avatar-image" [src]="item.avatarUrl" [alt]="item.name" />
                </ng-container>
                <ng-template #avatarTextFallback>
                  <span class="avatar">{{ vm.getAvatarText(item) }}</span>
                </ng-template>
              </div>
            </div>
            <div class="meta">
              <div class="title">{{ item.name }}</div>
              <div class="tags">
                <nz-tag>{{ vm.getSourceLabel(item.source) | i18n }}</nz-tag>
                <nz-tag [nzColor]="vm.getStatusColor(item.status)">{{ vm.getStatusLabel(item.status) | i18n }}</nz-tag>
                <nz-tag nzColor="gold" *ngIf="vm.isTrialAssistant(item)">{{ 'assistant.management.create.pay.trial.tag' | i18n }}</nz-tag>
                <nz-tag nzColor="blue">{{ vm.getResponseLabel(item.responseMode) | i18n }}</nz-tag>
              </div>
              <div class="desc">{{ vm.getAssistantDescription(item) }}</div>
              <div class="provider-meta" *ngIf="item.source === 'Subscription'">
                {{ 'assistant.store.table.provider' | i18n }}: {{ vm.getAssistantProviderName(item) }}
              </div>
              <div class="webhook" *ngIf="vm.shouldShowAssistantWebhook(item)">
                {{ 'assistant.management.webhook' | i18n }}: {{ item.webhookUrl }}
              </div>
              <div class="expiry-meta">
                <span class="expiry-item">
                  <i nz-icon nzType="calendar" nzTheme="outline"></i>
                  {{ 'robot-service.my.expire-date' | i18n }}: {{ vm.getAssistantExpireDateText(item) }}
                </span>
                <span class="expiry-item">
                  <i nz-icon nzType="clock-circle" nzTheme="outline"></i>
                  {{ 'robot-service.my.remaining' | i18n }}:
                  <span class="expiry-value" [class.expiry-value-expired]="vm.isExpiredAssistant(item)">
                    {{ vm.getAssistantRemainingText(item) }}
                  </span>
                </span>
              </div>
            </div>
          </div>

          <div class="card-actions">
            <button
              nz-button
              class="action-btn action-btn-edit"
              (click)="vm.configure(item)"
              [testId]="'assistant-management-configure-button-' + i"
            >
              <i nz-icon nzType="setting"></i>
              {{ 'assistant.management.action.configure' | i18n }}
            </button>
            <button
              nz-button
              nzType="primary"
              class="action-btn action-btn-view"
              [class.action-btn-pay-countdown]="vm.getPendingPaymentCountdown(item)"
              *ngIf="vm.isUnpaid(item) && !vm.shouldOfferSubscriptionRenewal(item)"
              [nzLoading]="vm.payingAssistantId() === item.id"
              [disabled]="!!vm.payingAssistantId() || !vm.canPayPendingAssistant(item)"
              (click)="vm.continuePay(item)"
              [testId]="'assistant-management-pay-button-' + i"
            >
              <i nz-icon [nzType]="vm.isPendingPaymentExpired(item) ? 'reload' : 'credit-card'"></i>
              <span class="pay-title">{{
                (vm.isPendingPaymentExpired(item) ? 'assistant.management.store.action.renew' : 'assistant.management.store.action.pay-now')
                  | i18n
              }}</span>
            </button>
            <button
              nz-button
              nzType="primary"
              class="action-btn action-btn-view"
              *ngIf="vm.shouldOfferSubscriptionRenewal(item)"
              (click)="vm.openSubscriptionRenewalPurchase(item)"
              [testId]="'assistant-management-renew-subscription-button-' + i"
            >
              <i nz-icon nzType="reload" nzTheme="outline"></i>
              {{ 'assistant.management.store.action.renew' | i18n }}
            </button>
            <button
              nz-button
              class="action-btn action-btn-warning"
              *ngIf="vm.canDisableAssistant(item)"
              (click)="vm.toggleStatus(item)"
              [testId]="'assistant-management-disable-button-' + i"
            >
              <i nz-icon nzType="pause-circle"></i>
              {{ 'assistant.management.action.disable' | i18n }}
            </button>
            <button
              nz-button
              class="action-btn action-btn-success"
              *ngIf="vm.canEnableAssistant(item)"
              (click)="vm.toggleStatus(item)"
              [testId]="'assistant-management-enable-button-' + i"
            >
              <i nz-icon nzType="play-circle"></i>
              {{ 'assistant.management.action.enable' | i18n }}
            </button>
            <button
              nz-button
              nzDanger
              class="action-btn action-btn-danger"
              *ngIf="vm.canDeleteAssistant(item)"
              (click)="vm.remove(item)"
              [testId]="'assistant-management-delete-button-' + i"
            >
              <i nz-icon nzType="delete"></i>
              {{ 'assistant.management.action.delete' | i18n }}
            </button>
          </div>
        </nz-card>
      </div>
      <div class="assistant-load-more" *ngIf="vm.loadingMore" testId="assistant-management-loading-more">
        {{ 'common.loading' | i18n }}
      </div>
    </div>
  </nz-spin>
</div>

<assistant-create-wizard [vm]="vm" />
